export default __webpack_public_path__ + "static/media/boy.5cde85a8.png";